/**
 * @deprecated Use orderStatesMixin instead
 */
export const OrderState = {
    Pending: 'pending',
    Confirmed: 'confirmed',
    Rejected: 'rejected',
    Cancelled: 'cancelled',
    Refunded: 'refunded',
    RefundPending: 'refund_pending',
    Send: 'send',
    ReadyForPickup: 'pickup',
    PickedUp: 'collected',
    WaitForIntegration: 'wait_for_integration',
    Delivered: 'delivered'
};
